import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=b28af2f8&scoped=true"
import script from "./Organization.vue?vue&type=script&lang=ts"
export * from "./Organization.vue?vue&type=script&lang=ts"
import style0 from "./Organization.vue?vue&type=style&index=0&id=b28af2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28af2f8",
  null
  
)

export default component.exports